import "./Participant.css";
import { Roles } from "../../shared/enums";
import { StreamManager } from "openvidu-browser-v2compatibility";
import { MediaStreamComponent } from "../VideoDisplayComponent/DisplayMediaStream";

export default function SubscriberComponent(props: { subscriber: StreamManager }) {
  return (
    <div className='remote-media'>
      <MediaStreamComponent title={Roles.Analyst} key={props.subscriber.id} mediaStream={props.subscriber} />
    </div>
  );
}
